import React, { useState, useEffect } from 'react';
import './add-employer.css';
import Grid from '@mui/material/Grid';
import http from '../../services/http-service'
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useHistory } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import checkValidationFormAllControls from '../../constants/validation';
import { getErrorResponse } from '../../utils';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

function AddEmployer(props) {
  const [countryCodeList, setCountryCodeList] = useState([])
  const [countryCode, setCountryCode] = useState('');
  const [open, setOpen] = useState(false);
  const [employeerDetails, getEmployeerDetails] = useState({});


  const fatchCountryCodes = () => {
    handleToggle()
    http('account/phone_code_list/', 'GET')
      .then(res => {
        if (res.data.status) {
          setCountryCodeList(res.data.data)
        }
        else {
          toast.error(res.data.message,{
            toastId: "toastId1"
          })

        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        })
  }
  const fetchUserDetails = () => {
    //handleToggle()
    http('admin/update_employer/' + props.match.params.id, 'GET', '')
      .then(res => {
        if (res.status) {

          var employerData = res.data.data;
          var company = employerData.company;
          delete employerData.company
          var objEmployer = Object.assign(company, employerData)
          getEmployeerDetails(objEmployer)
          var data = document.forms[0];
          Object.keys(objEmployer).forEach(element => {
            if (element === 'name') {
              data.elements['employer_name'].value = objEmployer[element]
            }
            if (element === 'first_name') {
              data.elements['contact_name'].value = objEmployer[element]
            }
            if (element === 'mobile') {
              data.elements['phone_number'].value = objEmployer[element]
            }
            if (element === 'phonecode') {
              setCountryCode(objEmployer[element])
            }
            if (data.elements[element]) {
              data.elements[element].value = objEmployer[element]
            }
          })

        }
        else {
          toast.error(res.message,{
            toastId: "toastId2"
          })
        }
      },
        err => {
          console.log('err....', err)
        });
  }
  useEffect(() => {
    fatchCountryCodes()
    if (props.match.params.id) {
      fetchUserDetails();
    }
    // eslint-disable-next-line
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const history = useHistory();
  const [errorDisplay, seterrorDisplay] = useState('')

  const goBack = () => {
    // history.push('/employer-list')
    history.goBack()
  }
  const submitForm = (event) => {
    event.preventDefault();
    var objValidation = {};
    objValidation = checkValidationFormAllControls(document.forms[0].elements, false, [])
    if (objValidation.valid !== false) {
      seterrorDisplay(objValidation);
      return;
    } else {
      seterrorDisplay(objValidation);
    }
    const data = new FormData(event.currentTarget);
    const body = {
      id: props.match.params.id ? props.match.params.id : '',
      employer_id: data.get('employer_id'),
      employer_name: data.get('employer_name'),
      legal_name: data.get('legal_name'),
      cac_registration_number: data.get('cac_registration_number'),
      tax_identification_number: data.get('tax_identification_number'),
      total_net_monthly_payroll: data.get('total_net_monthly_payroll'),
      total_number_of_employees: data.get('total_number_of_employees'),
      contact_name: data.get('contact_name'),
      email: data.get('email'),
      phone_number: countryCode + data.get('phone_number'),
      address: data.get('address'),
      address_line_2: data.get('address_line_2'),
      city: data.get('city'),
      region_code: data.get('region_code'),
      country_code: data.get('country_code'),
      postal_code: data.get('postal_code'),
      website: data.get('website')
    }
    handleToggle()
    var url = props.match.params.id ? 'admin/update_employer/' : 'admin/add_employer/';
    var method = props.match.params.id ? 'PUT' : 'POST'
    http(url, method, body)
      .then(res => res.data)
      .then(res => {
        if (res.status) {
          // history.push("/employer-list");
          history.goBack()
          toast.success(res.message,{
            toastId: "toastId3"
          })
        }
        else {
          const error = getErrorResponse(res.message)
          toast.error(error, { toastId:"toastId4", allowHtml: true })
        }
        handleClose()
      })
      .catch(error => {
        toast.error("Something went wrong!",{
          toastId: "toastId5"
        })
        handleClose()
      });
  }

  const preventMinus = (e) => {
    if (e.code === 'Minus') {
      e.preventDefault();
    }
  };

  const preventKeyDown = (e) => {
    if (e.code === 'ArrowDown') {
      e.preventDefault();
    }
  }

  return (

    <div className='mainAppDiv'>
      <ToastContainer />

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Typography variant="h5" className='AddEmployerHeadding' gutterBottom component="div">
        {props.match.params.id ? 'Edit' : 'Add'} Employer
      </Typography>
      <form onSubmit={submitForm} noValidate sx={{ mt: 1 }} className="formInputHeight">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4} >

            <TextField InputProps={{
              readOnly: props.match.params.id ? true : false,
            }} InputLabelProps={{ shrink: true }} required fullWidth label="Enter employer id " name='employer_id' id="employer_id" />
            {errorDisplay.employer_id ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.employer_id}</span> : ''}
          </Grid>
          <Grid item xs={12} sm={6} md={4} >

            <TextField InputLabelProps={{ shrink: true }} required fullWidth label="Enter employer name " name='employer_name' id="employer_name" />
            {errorDisplay.employer_name ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.employer_name}</span> : ''}
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter legal name" name='legal_name' id="legal_name" />
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} required fullWidth label="Enter cac registration number" name='cac_registration_number' id="cac_registration_number" />
            {errorDisplay.cac_registration_number ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.cac_registration_number}</span> : ''}
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} required fullWidth label="Enter tax identification number" name='tax_identification_number' id="tax_identification_number" inputProps={{ type: "tel", maxlength: "14", minlength: "14" }} />
            {errorDisplay.tax_identification_number ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.tax_identification_number}</span> : ''}
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} type="number" onKeyDown={preventKeyDown} onKeyPress={preventMinus} fullWidth label="Enter total net monthly payroll" name='total_net_monthly_payroll' id="total_net_monthly_payroll" inputProps={{ min: "1" }} />
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} type="number" onKeyDown={preventKeyDown} onKeyPress={preventMinus} fullWidth label="Enter total number of employees" name='total_number_of_employees' id="total_number_of_employees" inputProps={{ min: "1" }} />
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter contact name " name='contact_name' id="contact_name" />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField InputProps={{
              readOnly: props.match.params.id ? true : false,
            }} InputLabelProps={{ shrink: true }} required fullWidth label="Enter email" name='email' type="email" id="email" />
            {errorDisplay.email ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.email}</span> : ''}
          </Grid>

          {/* <Grid item xs={12} sm={6} md={4} >
            <TextField InputProps={{
              readOnly: props.match.params.id ? true : false,
            }} InputLabelProps={{ shrink: true }} required fullWidth label="Enter phone number" name='phone_number' id="phone_number" />
            {errorDisplay.phone_number ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.phone_number}</span> : ''}
          </Grid> */}
          <Grid item xs={12} sm={6} md={4} >
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <FormControl fullWidth className="cityHeight">
                  <InputLabel id="demo-simple-select-required-label">Code</InputLabel>
                  <Select
                    labelId="demo-simple-select-required-label"
                    id="country_phone_code"
                    name='country_phone_code'
                    value={countryCode}
                    label="Code*"
                    onChange={(event) => {
                      setCountryCode(event.target.value)
                    }}
                  >
                    <MenuItem value="" disabled="true">Please select</MenuItem>
                    {
                      countryCodeList.map((data, index) => (
                        <MenuItem key={'data.code' + index} value={data.code}>{data.name + " (" + data.code + ")"}</MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} >
                <TextField InputLabelProps={{ shrink: true }} required fullWidth label="Enter phone number" name='phone_number' id="phone_number" />
                {errorDisplay.phone_number ? <span style={{
                  fontSize: '14px',
                  color: '#dc0e0e'
                }}>{errorDisplay.phone_number}</span> : ''}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter address" name='address' id="address" />
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter address line 2" name='address_line_2' id="address_line_2" />
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter city" name='city' id="city" />
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter region code" name='region_code' id="region_code" />
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter country code" name='country_code' id="country_code" />
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter Postal Code" name='postal_code' id="postal_code" />
          </Grid>

          <Grid item xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter Website" name='website' id="website" />
          </Grid>
        </Grid>

        <div className='btnDiv'>
          <Grid container spacing={3} className='justifyEnd' sx={{ justifyContent: 'flex-end' }}>
            <Grid item xs={12} className='gridbtnSubmit'>
              <button type='button' className='btnSubmit btnCancel' onClick={goBack}>Cancel</button>
              <button type='submit' className='btnSubmit'>Submit</button>
            </Grid>
          </Grid>
        </div>
      </form>
    </div>
  );
}

export default AddEmployer;